import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as engagementBreakdown from './engagement-breakdown'
import * as teamMemberOverview from './team-member-overview'
import * as teamSpirit from './team-spirit'

export const DOC = gql`
  ${teamSpirit.DOC}
  ${teamMemberOverview.DOC}
  ${engagementBreakdown.DOC}
  fragment FragmentSummitPulse on SummitPulse {
    teamSpirit {
      ...FragmentSummitPulseTeamSpirit
    }
    teamMembersOverview {
      ...FragmentSummitPulseTeamMemberOverview
    }
    engagementBreakdown {
      ...FragmentSummitPulseEngagementBreakdown
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSummitPulseFragment,
  ents.core.summit.Pulse
>({
  engagementBreakdown: graphql.transformers.OUT.validate(
    engagementBreakdown.TRANSFORMER,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
  teamMembersOverview: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(teamMemberOverview.TRANSFORMER, {
      onNullish: 'remove',
    }),
    [],
  ),
  teamSpirit: graphql.transformers.OUT.validate(
    teamSpirit.TRANSFORMER,
    TypeAsserter.assertIsNotNullish,
    {
      warnOnly: true,
    },
  ),
})
